module.exports = __webpack_public_path__ + "img/PK_Asset_Info_Web_Text2.c45b7609.png";